<div class="modal-header">
    <h4 class="modal-title">Müşteri Onay Kodu</h4>
</div>
<div class="modal-body">
    <form [formGroup]="customerConfirmMailForm">
        <div class="col-12">
            <label>Kod</label>
            <div class="form-group">
                <input type="text" class="form-control" id="code" formControlName="code" />
                <span
                    *ngIf="customerConfirmMailForm.get('code').invalid && customerConfirmMailForm.get('code').touched"
                    class="text-danger">
                    Kod zorunludur.
                </span>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="customerConfirmMailForm.invalid" (click)="sendEmail()">
        Gönder
    </button>
</div>